import { render, staticRenderFns } from "./SelfServiceFiles/SelfService.html?vue&type=template&id=e9356f80&scoped=true&external"
import script from "./SelfServiceFiles/SelfService.js?vue&type=script&lang=js&external"
export * from "./SelfServiceFiles/SelfService.js?vue&type=script&lang=js&external"
import style0 from "./SelfServiceFiles/SelfService.scss?vue&type=style&index=0&id=e9356f80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9356f80",
  null
  
)

export default component.exports